var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbalaje1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86",
    "data-name": "Rect\\xE1ngulo 86",
    width: 19.18,
    height: 19.19,
    fill: "#1c1c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__embalaje_1",
    transform: "translate(-0.272 -0.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    transform: "translate(0.272 0.483)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    transform: "translate(13.682 13.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M17.147,8.579H14.891V2.033A2.035,2.035,0,0,0,12.858,0H6.322A2.036,2.036,0,0,0,4.289,2.033V8.579H2.033A2.035,2.035,0,0,0,0,10.611v6.546A2.035,2.035,0,0,0,2.033,19.19H8.568a1.748,1.748,0,0,0,1.019-.353,1.766,1.766,0,0,0,1.013.353h6.546a2.036,2.036,0,0,0,2.033-2.033V10.611a2.036,2.036,0,0,0-2.033-2.033M6.322,1.525H8.314V3.557a.51.51,0,0,0,.508.508h1.525a.5.5,0,0,0,.508-.508V1.525h2a.51.51,0,0,1,.508.508V8.579H5.814V2.033a.51.51,0,0,1,.508-.508M8.828,17.157a.51.51,0,0,1-.508.508H2.033a.51.51,0,0,1-.508-.508V10.611a.5.5,0,0,1,.508-.508h2v2.033a.51.51,0,0,0,.508.508H6.068a.516.516,0,0,0,.508-.508V10.1H8.828Zm8.828,0a.516.516,0,0,1-.508.508H10.86a.516.516,0,0,1-.508-.508V10.1H12.6v2.033a.51.51,0,0,0,.508.508h1.525a.51.51,0,0,0,.508-.508V10.1h2a.51.51,0,0,1,.508.508Z",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbalaje1);
export default __webpack_public_path__ + "static/media/__embalaje_1.07ed8dbf29092ba473c1cda6e1d3f869.svg";
export { ForwardRef as ReactComponent };